import dayjs, { extend } from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

extend(relativeTime, {
	rounding: Math.floor,
	thresholds: [
		{ l: 's', r: 1, d: 'second' },
		{ l: 'm', r: 1 },
		{ l: 'mm', r: 59, d: 'minute' },
		{ l: 'h', r: 1 },
		{ l: 'hh', r: 23, d: 'hour' },
		{ l: 'd', r: 1 },
		{ l: 'dd', r: 30, d: 'day' },
		{ l: 'M', r: 1 },
		{ l: 'MM', r: 11, d: 'month' },
		{ l: 'y', r: 1 },
		{ l: 'yy', d: 'year' },
	],
});

export default dayjs;
